import * as PIXI from 'pixi.js';
import gsap from 'gsap';
import { APP_WIDTH, APP_HEIGHT } from '../utils/commonUtils';

import HandContainer from './handContainer';
import CardContainer from './cardContainer';
import ActionButtonsContainer from './actionButtonsContainer';

export default class SearchDeckContainer extends PIXI.Container {
    constructor() {
        super();

        this.handContainer = new HandContainer(0, []);
        this.handContainer.label = 'handContainer';
        this.handContainer.scale.set(1.3);
        this.handContainer.x = 0;
        this.handContainer.y = -500;
        this.addChild(this.handContainer);
    }

    update(gameState) {
        if (gameState.pendingAction?.type !== 'EFFECT_STEP_RESOLUTION' || gameState.pendingAction?.expectedResponseType !== 'searchDeck') {
            return;
        }

        const hand = gameState.pendingAction.searchCards.map(card => {
            if (gameState.pendingAction.revealWhileSearching) {
                return card;
            }
            
            return { instanceId: card.instanceId };
        });

        this.handContainer.scale.set(hand.length <= 5 ? 1.3 : 1.0);
        this.handContainer.updateHand({}, { handCount: gameState.pendingAction.searchCards.length, hand }, {});
    }

    async playOpponentRevealCardsAnimation(cards) {
        const revealedCard = cards[0];
        if (!revealedCard) {
            return;
        }

        const cardContainer = this.handContainer.children.find(child => child.cardInstance?.instanceId === revealedCard.instanceId);
        if (!cardContainer) {
            return;
        }

        const cardVisualsContainer = cardContainer.getChildByLabel('cardVisualsContainer');

        const screenCenterPosition = this.handContainer.toLocal({ x: APP_WIDTH / 2, y: APP_HEIGHT / 2 });

        await gsap.timeline().timeScale(0.5).to(cardVisualsContainer, {
            duration: 0.2,
            ease: 'power3.in',
            pixi: {
                scaleX: 0,
            }
        }).call(() => {
            cardContainer.updateCardInstance(revealedCard);
            cardContainer.showFrontFace();
            cardContainer.hidePowerText();
            cardContainer.zIndex = 100;
        }).to(cardVisualsContainer, {
            duration: 0.2,
            ease: 'power3.out',
            pixi: {
                scaleX: 1,
            }
        }).to(cardContainer, {
            duration: 0.5,
            ease: 'power3.inOut',
            pixi: {
                x: screenCenterPosition.x,
                y: screenCenterPosition.y + 150,
                scale: 1.9,
                angle: 0,
            }
        }, '0').call(() => {}, [], '1.2').to(cardContainer, {
            duration: 0.25,
            ease: 'power2.out',
            pixi: {
                y: -520,
            }
        }).to(cardContainer, {
            duration: 0.15,
            ease: 'power3.out',
            pixi: {
                scale: 0.77,
            }
        }, '<');
    }
}